import React from "react";

interface Props {
  children: React.ReactNode;
}

const GradientCard = ({ children }: Props) => (
  <div>
    {children}
    <style jsx>{`
      div {
        flex-direction: column;
        display: flex;
        box-shadow: 2px 2px 10px rgba(166, 171, 189, 0.5);
        border-top: 3px solid;
        border-radius: 10px;
        margin: 20px 0 30px 0;
        border-top: double 3px transparent;
        background-image: linear-gradient(white, white),
          radial-gradient(circle at top left, #8f2398, #3e93d3);
        background-origin: border-box;
        background-clip: content-box, border-box;
      }
    `}</style>
  </div>
);

export default GradientCard;
